import { Injectable } from "@angular/core";
import { HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable()
export abstract class RemoteRepositoryInterface {

    public abstract get(url: string, headers?: HttpHeaders, baseUrl?: string): Observable<{}>;

    public abstract post(url: string, body: unknown, headers?: HttpHeaders): Observable<{}>;

    public abstract postWithoutErrors(url: string, body: unknown, headers?: HttpHeaders): Observable<{}>;

    public abstract postWithProgress(url: string, body: unknown, headers?: HttpHeaders): Observable<{}>;

    public abstract update(url: string, body: unknown): Observable<{}>;

    public abstract delete(url: string): Observable<{}>;

    public abstract deleteWithBody(url: string, body: unknown): Observable<{}>
}
